define( function() {
	return ( /<([\w:-]+)/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/var/rtagName.js
 ** module id = 845
 ** module chunks = 2
 **/